module.exports = __webpack_public_path__ + "img/2-fa-disabled.47467195.svg";